module.exports = __webpack_public_path__ + "c65af695.svg";